export default __webpack_public_path__ + "line-chart-cca2a94c034107d265f96fd568e35f8a.svg";